import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Pagination,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { NotificationManager } from "react-notifications";
import getFilterServices from "../../../services/getFilterServices";

const List = ({
  open,
  setOpen,
  dialogType,
  setDialogType,
  editValue,
  setEditValue,
  fetchedData,
  filterVal,
  setFilterVal,
  fetchData,
  totalPages,
  currentPage,
  onPageChange,
  loading,
}) => {
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [itemToDeleteId, setItemToDeleteId] = useState(null);

  const handleEdit = (row) => {
    setEditValue(row);
    setDialogType("update");
    setOpen(true);
  };

  const handleDeleteClick = (id) => {
    setItemToDeleteId(id);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = async () => {
    setDeleteConfirmOpen(false);
    if (itemToDeleteId) {
      try {
        const response = await getFilterServices.DeleteManualJournal(
          itemToDeleteId
        );
        if (response?.success) {
        
          fetchData();
        }
      } catch (error) {
        NotificationManager.error(
          "Error deleting  journal",
          "Error"
        );
      }
    }
    setItemToDeleteId(null);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setItemToDeleteId(null);
  };

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage);
  };

  // Calculate the start and end indices for the current page
  const startIndex = (currentPage - 1) * filterVal.limit;
  const endIndex = startIndex + filterVal.limit;
  const currentPageData = fetchedData.slice(startIndex, endIndex);

  return (
    <div>
      <TableContainer
        component={Paper}
        sx={{
          height: "330px",
          overflow: "auto",
          "& .MuiTable-root": {
            height: "100%",
          },
          "& .MuiTableBody-root": {
            overflowY: "auto",
            flexGrow: 1,
          },
          "& .MuiTableHead-root": {
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 1,
          },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell className="text-end">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={2} sx={{ border: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              currentPageData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={2} sx={{ textAlign: "center", border: 0 }}>
                  <b> No search result found</b>

                  </TableCell>
                </TableRow>
              ) : (
                currentPageData.map((row) => (
                  <TableRow key={row.journalid}>
                    <TableCell>{row.journalName}</TableCell>
                    <TableCell className="text-end">
                      <IconButton
                        color="primary"
                        onClick={() => handleEdit(row)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteClick(row.journalid)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChangePage}
          color="primary"
          showFirstButton
          showLastButton
          sx={{
            "& .MuiPaginationItem-root": {
              fontSize: "1rem",
            },
            "& .Mui-selected": {
              backgroundColor: "#1976d2 !important",
              color: "white",
            },
          }}
        />
      </Box>

      <Dialog
        open={deleteConfirmOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <p id="alert-dialog-description">
            Are you sure you want to delete this journal?
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default List;
